module.exports = __webpack_public_path__ + "img/spouse.37001317.svg";